/* (ignored) */


//////////////////
// WEBPACK FOOTER
// ws (ignored)
// module id = 2
// module chunks = main